import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked text reveal used in the hero
export const MaskLines = ({ lines, className = "", delay = 0, start = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : { y: "110%" }}
          transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export { EASE };
